import PropTypes from 'prop-types';
// @flow

import React from 'react';
import _ from 'lodash';

import I18n from 'PMT/i18n/I18n';

// -- constants
import ViewConstants from 'constants/ViewConstants';
import ApiConstants from 'PMT/constants/ApiConstants';
import RoutingEnum from 'constants/RoutingEnum';

// -- actions
import { RestaurantMenuAction, RouteAction } from 'actions';

// -- utils
import SecurityContext from 'utils/permissions/SecurityContext';
import Notify from 'PMT/utils/Notify';

// -- entities
import ProductCategory from 'PMT/entities/menu/ProductCategory';
import RestaurantMenu from 'PMT/entities/menu/RestaurantMenu';
import CategoryItem from 'PMT/entities/menu/CategoryItem';
import Product from 'PMT/entities/menu/Product';
import Menu from 'PMT/entities/menu/Menu';

// -- views
import AbstractRestaurantMenuForm from '../components/AbstractRestaurantMenuForm';
import FixedSubmitArea from 'PMT/components/form/FixedSubmitArea';
import ImageDropzone from 'PMT/components/form/ImageDropzone';
import CategoryDetailProductRow from './components/CategoryDetailProductRow';
import CategoryDetailMenuRow from './components/CategoryDetailMenuRow';
import CategoryDetailChildCategoryRow from './components/CategoryDetailChildCategoryRow';
import { RoundButton } from 'components';
import SortableList from 'PMT/components/SortableList';
import AddItemToCategoryModal from './addItemToCategory/AddItemToCategoryModal';
import { EditProductCategoryModal } from 'components/restaurantMenu';

export default class ProductCategoryDetailView extends AbstractRestaurantMenuForm {

  static propTypes = {
    productCategory: PropTypes.instanceOf(ProductCategory).isRequired,

    restaurantMenu: PropTypes.instanceOf(RestaurantMenu).isRequired,

    onUpdate: PropTypes.func.isRequired,

    onImageRemove: PropTypes.func.isRequired,

    currencyCode: PropTypes.string,

  };

  componentWillReceiveProps(nextProps: Object) {
    super.componentWillReceiveProps(nextProps);
  }

  getDefaultState(props: Object) {
    return {
      productCategory: props.productCategory.copy(),

      displayAddItemModal: false,

      image: null,

      displayEditModal: false
    };
  }

  shouldUpdateState(nextProps: Object) {
    return !this.props.productCategory.equals(nextProps.productCategory);
  }

  onOrderChange = (items) => {
    const productCategory: ProductCategory = this.productCategory;

    productCategory.items = items;

    this.setState({
      productCategory
    });
  };

  onDeleteProductFromCategory = (product: Product) => {
    Notify.confirm(I18n.tr('menu.category.detail.confirm_delete_product'), (result) => {
      if (result) {
        const productCategory: ProductCategory = this.productCategory;

        productCategory.removeItemWithId(product.id);

        this.setState({
          productCategory
        });
      }
    });
  };

  onDeleteMenuFromCategory = (menu: Menu) => {
    Notify.confirm(I18n.tr('menu.category.detail.confirm_delete_menu'), (result) => {
      if (result) {
        const productCategory: ProductCategory = this.productCategory;

        productCategory.removeItemWithId(menu.id);

        this.setState({
          productCategory
        });
      }
    });
  };

  onDeleteChildCategoryFromCategory = (category: ProductCategory) => {
    Notify.confirm(I18n.tr('menu.category.detail.confirm_delete_child_category'), (result) => {
      if (result) {
        const productCategory: ProductCategory = this.productCategory;

        productCategory.removeItemWithId(category.id);

        this.setState({
          productCategory
        });
      }
    });
  };

  // -- events navigation
  onDisplayProductDetail = (product: Product) => {
    RouteAction.presentProductEdit(product);
  };

  onDisplayMenuDetail = (menu: Menu) => {
    RouteAction.presentMenuDetail(menu);
  };


  //
  // Edit modal events
  //

  onEditClicked = () => {
    this.setState({
      displayEditModal: true
    });
  };

  onDeleteClicked = () => {
    Notify.confirm(I18n.tr('menu.category.confirm_deletion'), (result) => {
      if (result) {
        const restaurantMenu: RestaurantMenu = this.props.restaurantMenu;

        restaurantMenu.removeCategory(this.state.productCategory);

        this.setState({
          loading: true,
        }, () => {
          RouteAction.redirectTo(RoutingEnum.RESTAURANT_MENU);
          RestaurantMenuAction.saveRestaurantMenu(restaurantMenu);
        });
      }
    });
  };

  onHideEditModal = () => {
    this.setState({
      displayEditModal: false
    });
  };


  // -- getters

  get productCategory(): ProductCategory {
    return this.state.productCategory;
  }

  get currencyCode(): string {
    return this.props.currencyCode;
  }

  get haveModifications(): boolean {
    return !this.props.productCategory.equals(this.state.productCategory)
      || !_.isNull(this.state.image);
  }

  onFormSubmit = () => {
    this.props.onUpdate(this.productCategory, this.state.image);
  };

  onFormReset = () => {
    this.setState({
      productCategory: this.props.productCategory.copy(),
      image: null
    });
  };

  // -- events add item modal

  onDisplayAddItemModal = () => {
    this.setState({
      displayAddItemModal: true
    });
  };

  onHideAddItemModal = () => {
    this.setState({
      displayAddItemModal: false
    });
  };

  // -- image

  onImageChange = (pictureData: string) => {
    this.setState({
      image: pictureData
    });
  };

  onImageRemove = () => {
    this.props.onImageRemove(this.productCategory);
  };

  onProductCategoryChange = (productCategory: ProductCategory) => {
    this.setState({
      productCategory
    });
  }

  // -- renderers

  renderImage() {
    return (
      <ImageDropzone
        editOnly={false}
        readOnly={!SecurityContext.restaurantMenu.canEdit()}
        className="product_category_view__image"
        placeholder={ViewConstants.Image.RestaurantMenu.NO_IMAGE_FOR_CATEGORY}
        image={this.productCategory.image}
        currentImage={this.state.image}
        onChange={this.onImageChange}
        onRemove={this.onImageRemove}
        aspectRatio={ApiConstants.Image.RestaurantMenu.Category.RATIO}
        width={ApiConstants.Image.RestaurantMenu.Category.WIDTH}
        height={ApiConstants.Image.RestaurantMenu.Category.HEIGHT}
        maxSize={ApiConstants.Image.RestaurantMenu.Category.MAX_SIZE}
      />
    );
  }

  renderTheadContentItemList() {
    return (
      <div className="thead col-xs-12">
        <div className="col-md-2 hidden-sm" />
        <div className="col-xs-6">
          {I18n.tr('menu.category.detail.table.header.name')}
        </div>
        <div className="col-xs-2 text-left">
          {I18n.tr('menu.category.detail.table.header.modes_and_price')}
        </div>

        {SecurityContext.restaurantMenu.canEdit() &&
          <div className="col-xs-1 text-center">
            {I18n.tr('menu.category.detail.table.header.delete_from_category')}
          </div>
        }

        {SecurityContext.restaurantMenu.canEdit() &&
          <div className="col-xs-1 text-center">
            {I18n.tr('menu.category.detail.table.header.move')}
          </div>
        }

      </div>
    );
  }

  renderRow = (item: CategoryItem) => {
    if (item.isProduct()) {
      const product: Product = this.props.restaurantMenu.getProductWithId(item.id);
      if (_.isNull(product)) {
        return (null);
      }
      return (
        <CategoryDetailProductRow
          product={product}
          key={product.id}
          onDeleteFromCategory={this.onDeleteProductFromCategory}
          currencyCode={this.currencyCode}
        />
      );
    } else if (item.isMenu()) {
      const menu: Menu = this.props.restaurantMenu.getMenuWithId(item.id);
      if (_.isNull(menu)) {
        return (null);
      }
      return (
        <CategoryDetailMenuRow
          menu={menu}
          key={menu.id}
          onDeleteFromCategory={this.onDeleteMenuFromCategory}
          currencyCode={this.currencyCode}
        />
      );
    } else if (item.isCategory()) {
      const category: ProductCategory = this.props.restaurantMenu.getCategoryWithId(item.id);
      if (_.isNull(category)) {
        return (null);
      }
      return (
        <CategoryDetailChildCategoryRow
          category={category}
          key={category.id}
          onDeleteFromCategory={this.onDeleteChildCategoryFromCategory}
        />
      );
    }

    return (null);
  };

  renderItemsList() {
    return (
      <SortableList
        items={this.productCategory.items}
        onChange={this.onOrderChange}
        renderer={this.renderRow}
        displayDragIcon={false}
      />
    );
  }

  renderDescription() {
    if (_.isEmpty(this.productCategory.description)) {
      return (
        <p><em>{I18n.tr('menu.category.detail.no_description')}</em></p>
      );
    }

    return (
      <p>{this.productCategory.description}</p>
    );
  }

  renderSubmitArea() {
    return (
      <FixedSubmitArea
        onSubmit={this.onFormSubmit}
        onReset={this.onFormReset}
        haveModifications={this.haveModifications}
      />
    );
  }

  renderAddItemToCategoryModal() {
    return (
      <AddItemToCategoryModal
        show={this.state.displayAddItemModal}
        onHide={this.onHideAddItemModal}
        restaurantMenu={this.props.restaurantMenu}
        productCategory={this.state.productCategory}
      />
    );
  }

  renderEditModal() {
    if (this.state.displayEditModal) {
      return (
        <EditProductCategoryModal
          productCategory={this.productCategory}
          onUpdate={this.onProductCategoryChange}
          show={this.state.displayEditModal}
          onHide={this.onHideEditModal}
        />
      );
    }

    return (null);
  }

  renderEditButton() {
    if (!SecurityContext.restaurantMenu.canEdit()) {
      return (null);
    }

    return (
      <button
        className="btn btn-primary"
        onClick={this.onEditClicked}
      >
        <i className="fa fa-edit" />
        &nbsp;&nbsp;
        {I18n.tr('menu.category.detail.edit')}
      </button>
    );
  }

  renderDeleteButton() {
    if (!SecurityContext.restaurantMenu.canEdit()) {
      return (null);
    }

    return (
      <button
        className="btn btn-danger"
        onClick={this.onDeleteClicked}
      >
        <i className="fa fa-trash" />
        &nbsp;&nbsp;
        {I18n.tr('menu.category.detail.delete')}
      </button>
    );
  }

  render() {
    return (
      <div className="product_category_view">

        <div className="row">
          <div className="col-xs-12 col-md-4">
            <h3>{this.productCategory.name}</h3>
            {/* {this.renderDescription()} */}
          </div>

          <div className="hidden-xs col-md-6">
            {this.renderImage()}
          </div>

          <div className="col-sm-2">
            {this.renderEditButton()}
            {this.renderDeleteButton()}
          </div>
        </div>

        <hr />

        {SecurityContext.restaurantMenu.canEdit() &&
          <div className="top-buffer-30">
            <RoundButton
              text={I18n.tr('menu.category.detail.add_to_category')}
              onClick={this.onDisplayAddItemModal}
            />
          </div>
        }

        <div className="top-buffer-30 table_container table_container_hover row">
          {this.renderTheadContentItemList()}
          {this.renderItemsList()}
        </div>

        {this.renderSubmitArea()}

        {this.renderAddItemToCategoryModal()}
        {this.renderLoading()}
        {this.renderEditModal()}
      </div>
    );
  }

}
